import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=01960335&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=01960335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01960335",
  null
  
)

export default component.exports